module.exports = __webpack_public_path__ + "static/img/layout2.6998e5f2.jpg";